import assertOkResponseCode from '../assertOkResponseCode';
import encodeQueryParams from '../encodeQueryParams';

const API_URL = 'https://api.wise.com/v4/comparisons';
const V3_API_URL = 'https://api.wise.com/v3/comparisons';

function fetchQuotes(
  sourceCurrency,
  targetCurrency,
  sendAmount,
  midMarketRate,
  wiseFee,
  { providerCountry, sourceCountry, targetCountry, filter, includeWise, numberOfProviders } = {},
  providerTypes = undefined,
) {
  const query = encodeQueryParams({
    sourceCurrency,
    targetCurrency,
    sendAmount,
    midMarketRate,
    wiseFee,
    providerCountry,
    sourceCountry,
    targetCountry,
    providerTypes,
    filter,
    includeWise,
    numberOfProviders,
  });

  return fetch(`${API_URL}${query}`, { method: 'GET' })
    .then(assertOkResponseCode)
    .then((response) => response.json())
    .catch((error) => {
      return {
        providers: [],
      };
    });
}

export function fetchV3Quotes(
  sourceCurrency,
  targetCurrency,
  sendAmount,
  midMarketRate,
  wiseFee,
  { providerCountry, sourceCountry, targetCountry } = {},
  providerType = undefined,
) {
  const query = encodeQueryParams({
    sourceCurrency,
    targetCurrency,
    sendAmount,
    midMarketRate,
    wiseFee,
    providerCountry,
    sourceCountry,
    targetCountry,
    providerType,
  });

  return fetch(`${V3_API_URL}${query}`, { method: 'GET' })
    .then(assertOkResponseCode)
    .then((response) => response.json());
}

export default fetchQuotes;
